import React, { Suspense, lazy } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { StickyOfferButton } from './components/StickyOfferButton';
import { UrgencyBar } from './components/UrgencyBar';
import { CreatorSection } from './components/CreatorSection';
import { DeferredSection } from './components/DeferredSection';
// Lazy load below-the-fold components
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const SuccessStories = lazy(() => import('./components/SuccessStories').then(m => ({
  default: m.SuccessStories
})));
const ProjectCarousel = lazy(() => import('./components/ProjectCarousel').then(m => ({
  default: m.ProjectCarousel
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const ImpactShowcase = lazy(() => import('./components/ImpactShowcase').then(m => ({
  default: m.ImpactShowcase
})));
const UpsellBox = lazy(() => import('./components/UpsellBox').then(m => ({
  default: m.UpsellBox
})));
const CommentsSection = lazy(() => import('./components/CommentsSection').then(m => ({
  default: m.CommentsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  return <div className="min-h-screen bg-transparent font-sans selection:bg-[#ec4899]/30 selection:text-white text-white" data-id="element-0" data-mp="nuhj4kutefvc">
      <Suspense fallback={null} data-id="element-1" data-mp="st2kinlsz5ld">
        <MetaPixel data-id="element-2" data-mp="36hx792iaw2a" />
      </Suspense>
      <TopBanner data-id="element-3" data-mp="35gkl05ue1ig" />
      <UrgencyBar data-id="element-4" data-mp="34x1hg4gh72u" />
      <StickyOfferButton data-id="element-5" data-mp="38kxqn1ac7l9" />

      <main className="flex flex-col" data-id="element-6" data-mp="3ud1gzdqblwcq">
        <HeroSection data-id="element-7" data-mp="3ubzsa6gdtbcj" />

        <DeferredSection minHeight="400px" data-id="element-8" data-mp="3ucje3y95kjvu">
          <Suspense fallback={<div className="min-h-[400px]" data-id="element-10" data-mp="d3mkjc838xko" />} data-id="element-9" data-mp="d57h17dyqql6">
            <ComparisonTable data-id="element-11" data-mp="d2biphy7dzw7" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="800px" data-id="element-12" data-mp="864djrdmssfb">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-14" data-mp="3gklbm69y5m8n" />} data-id="element-13" data-mp="3gl4rlhg1e0k1">
            <SuccessStories data-id="element-15" data-mp="3gja6o34rm8fy" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="500px" data-id="element-16" data-mp="3bnuurgqbimm6">
          <Suspense fallback={<div className="min-h-[500px]" data-id="element-18" data-mp="3qbpql5zmh73h" />} data-id="element-17" data-mp="3qb7jtffc3ahb">
            <ProjectCarousel data-id="element-19" data-mp="3qcinzgcoyk8y" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-20" data-mp="3ljpigq9ef7vt">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-22" data-mp="2xumznf3138zq" />} data-id="element-21" data-mp="3limv2sbabnkn">
            <WhatYouGet data-id="element-23" data-mp="2xtc05rgm8nef" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="800px" data-id="element-24" data-mp="2swlgyv9ilbos">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-26" data-mp="18drky0d87nfx" />} data-id="element-25" data-mp="2stpkzch88x2z">
            <BonusGrid data-id="element-27" data-mp="18czmmhs8vbly" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="500px" data-id="element-28" data-mp="1d4ztyvan96sk">
          <Suspense fallback={<div className="min-h-[500px]" data-id="element-30" data-mp="1d6awkrscs8i3" />} data-id="element-29" data-mp="1d5srd5npqjy1">
            <ImpactShowcase data-id="element-31" data-mp="ygd5a2z4n2oo" />
          </Suspense>
        </DeferredSection>

        <CreatorSection data-id="element-32" data-mp="13eeuz6r26094" />

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-34" data-mp="13f7txljrzlgp" />} data-id="element-33" data-mp="13fpz57of1a0r">
          <UpsellBox data-id="element-35" data-mp="1r4io2k6mehlv" />
        </Suspense>

        <DeferredSection minHeight="800px" data-id="element-36" data-mp="1r5kcrrgk72m2">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-38" data-mp="1w33sywwthpgn" />} data-id="element-37" data-mp="1r2fwvwtqeifk">
            <CommentsSection data-id="element-39" data-mp="1w2tzv0gh726q" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-40" data-mp="1i2j7tu3fjhjz">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-42" data-mp="1m4wb8bupf3dl" />} data-id="element-41" data-mp="1i5x90z0cxkpu">
            <TestimonialsSection data-id="element-43" data-mp="1m3v2ie15usz1" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-44" data-mp="6nco4jb99x0l">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-46" data-mp="aq0yivfmbbzo" />} data-id="element-45" data-mp="6qies2zj96yf">
            <FAQSection data-id="element-47" data-mp="aqsh95o49f8j" />
          </Suspense>
        </DeferredSection>
      </main>

      <footer className="bg-transparent py-12 border-t border-[#27272a] text-center" role="contentinfo" data-id="element-48" data-mp="qy74n4km57a5">
        <div className="max-w-7xl mx-auto px-4" data-id="element-49" data-mp="m548coogbjq9">
          <p className="text-gray-400 text-sm mb-2" data-id="element-50" data-mp="h6sy4cu8v77i">
            © 2026 Neon Flex Academy. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-sm mb-4" data-id="element-51" data-mp="c9khigoqvb8d">
            Soporte:{' '}
            <a href="mailto:soportesinfinstudio@gmail.com" className="hover:text-white transition-colors" data-id="element-52" data-mp="19w9kotv6ntvt">
              soportedigitalfactory@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-53" data-mp="zw8z119ud1og">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}